export const ID_TYPE_OPTIONS = Object.freeze({
  IDENTITY_CARD: 'identity_card',
  PASSPORT: 'passport',
  DRIVING_LICENSE: 'driving_license',
  RESIDENCE_PERMIT: 'residence_permit',
  OTHER: 'other',
})
